const date = new Date();
const weekday = new Array(7);
weekday[0] = "dimanche";
weekday[1] = "lundi";
weekday[2] = "mardi";
weekday[3] = "mercredi";
weekday[4] = "jeudi";
weekday[5] = "vendredi";
weekday[6] = "samedi";
const monthday = new Array(12);
monthday[0] = "Janvier";
monthday[1] = "Février";
monthday[2] = "Mars";
monthday[3] = "Avril";
monthday[4] = "Mai";
monthday[5] = "Juin";
monthday[6] = "Juillet";
monthday[7] = "Août";
monthday[8] = "Septembre";
monthday[9] = "Octobre";
monthday[10] = "Novembre";
monthday[11] = "Décembre";
const sendDate = () => {
    let deliver = weekday[date.getDay()];
    let day = date.getDate();
    let month = monthday[date.getMonth()];
    let year = date.getFullYear();
    document.getElementById("deliveryday").innerHTML = deliver + ' ' + day + ' ' + month;
}
/*
 const deliveryDay = () => {
    if (d.getDay() > 0 && d.getDay() < 3) {
        d.setHours(d.getHours() + 72);
        sendDate();
    } else if (d.getDay() == 0) {
        d.setHours(d.getHours() + 120);
        sendDate();
    } else {
        d.setHours(d.getHours() + 144);
        sendDate();
    }
}
*/


const deliveryDay = () => {
    if (date.getDay() > 0 && date.getDay() < 3) {
        date.setHours(date.getHours() + 72);
        sendDate();
    } else if (date.getDay() == 0) {
        date.setHours(date.getHours() + 120);
        sendDate();
    } else {
        date.setHours(date.getHours() + 144);
        sendDate();
    }
}

deliveryDay();